<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-07-05 16:31:19
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-13 18:36:05
 * @FilePath: \partner.chaoyongtuan.com\src\views\shopManage\selectionDecoration\list\components\tableCells\titleCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="bannerNameCell yx-color-pure-1">
		<el-tooltip placement="top" :content="row.title" v-ak-tooltip-auto-show>
			<p class="line-ellipsis-1 font-h4-regular" style="width: 100%;">{{ row.title }}</p>
		</el-tooltip>
		<p class="font-h4-medium">ID：{{ row.id }}</p>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	data() {
		return {};
	},
};
</script>
<style lang="less" scoped>
.bannerCell {
}
</style>
